import BreadcrumbItem from "../breadcrumbs/BreadcrumbItem";

// Create the Path for team from breadcrubs Eg. Amazon > AWS > EC2
const BuildTeamPath = (
  team: BreadcrumbItem[],
  includeCurrentTeam: boolean
): string => {
  // In case if we want to pop the element better to create a cloned copy of list so it doesn't disturb existing list.
  const teamCopy = Object.assign([], team);
  if (!includeCurrentTeam) {
    teamCopy.pop();
  }
  return teamCopy
    .map((breadcrumb: BreadcrumbItem) => breadcrumb.name)
    .join(" > ");
};

export default BuildTeamPath;
